/* COD theme behaviour: sticky order bar, gallery, click-to-play video, drawer. No dependencies. */
(() => {
  const rtl = document.documentElement.dir === 'rtl';
  let stickyObserver;

  // Sticky bar: visible only once #order-form has scrolled out above the viewport.
  function initSticky() {
    if (stickyObserver) stickyObserver.disconnect();
    const bar = document.querySelector('[data-cod-sticky]');
    const form = document.getElementById('order-form');
    if (!bar) return;

    const show = (visible) => {
      bar.classList.toggle('is-visible', visible);
      bar.inert = !visible;
    };
    show(false);
    if (!form || !('IntersectionObserver' in window)) return;

    stickyObserver = new IntersectionObserver(([entry]) => {
      show(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    });
    stickyObserver.observe(form);
  }

  // Gallery: dots follow the swipe, arrows scroll one slide, autoplay video pauses off-screen.
  function initGallery(gallery) {
    const track = gallery.querySelector('.cod-gallery__track');
    const slides = Array.from(track.children);
    const dots = Array.from(gallery.querySelectorAll('.cod-gallery__dot'));

    gallery.querySelectorAll('[data-cod-nav]').forEach((button) => {
      button.addEventListener('click', () => {
        const step = Number(button.dataset.codNav) * (rtl ? -1 : 1);
        track.scrollBy({ left: step * track.clientWidth, behavior: 'smooth' });
      });
    });

    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = slides.indexOf(entry.target);
          const video = entry.target.querySelector('video[data-cod-autoplay]');
          if (entry.isIntersecting) {
            dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
            if (video) video.play().catch(() => {});
          } else if (video) {
            video.pause();
          }
        });
      },
      { root: track, threshold: 0.6 }
    );
    slides.forEach((slide) => observer.observe(slide));
  }

  function init() {
    initSticky();
    document.querySelectorAll('[data-cod-gallery]:not([data-cod-ready])').forEach((gallery) => {
      gallery.dataset.codReady = '';
      initGallery(gallery);
    });
  }

  const closeDrawers = () => {
    document.querySelectorAll('details.cod-drawer[open]').forEach((drawer) => {
      drawer.open = false;
      drawer.querySelector('summary').focus();
    });
  };

  document.addEventListener('click', (event) => {
    // Click-to-play video: the <video> only exists after the tap.
    const poster = event.target.closest('.cod-video__poster');
    if (poster) {
      const wrapper = poster.parentElement;
      wrapper.replaceChildren(wrapper.querySelector('template').content.cloneNode(true));
      const video = wrapper.querySelector('video');
      video.focus();
      video.play().catch(() => {});
      return;
    }

    if (event.target.closest('[data-cod-close]')) closeDrawers();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawers();
  });

  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
